import { SVGProps } from './types';

const Recommended = (props: SVGProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99935 1.66675L8.91477 6.00507C8.70313 6.85162 8.59731 7.2749 8.37692 7.61932C8.18197 7.92398 7.92325 8.18271 7.61859 8.37765C7.27416 8.59804 6.85089 8.70386 6.00434 8.9155L1.66602 10.0001L6.00434 11.0847C6.85089 11.2963 7.27416 11.4021 7.61859 11.6225C7.92325 11.8175 8.18198 12.0762 8.37692 12.3808C8.59731 12.7253 8.70313 13.1485 8.91477 13.9951L9.99935 18.3334L11.0839 13.9951C11.2956 13.1485 11.4014 12.7253 11.6218 12.3808C11.8167 12.0762 12.0755 11.8175 12.3801 11.6225C12.7245 11.4021 13.1478 11.2963 13.9944 11.0847L18.3327 10.0001L13.9944 8.9155C13.1478 8.70386 12.7245 8.59804 12.3801 8.37765C12.0755 8.18271 11.8167 7.92398 11.6218 7.61932C11.4014 7.2749 11.2956 6.85162 11.0839 6.00507L9.99935 1.66675Z"
        stroke="#187BDB"
        stroke-width="1.46"
        stroke-linecap="square"
      />
    </svg>
  );
};

export { Recommended };
